/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSummary } from './courseModuleSummary';

export type GenericApiResponseCourseModuleSummaryData = CourseModuleSummary | null;
